// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceUnit-module--price--1f44A","symbol":"PriceUnit-module--symbol--1P7jy","small":"PriceUnit-module--small--37Lqr","badge":"PriceUnit-module--badge--3aI9M"};